<div class=" " [hidden]="!showRequest" [class.read-only-content]="isReadOnly">
  <h2 class="sectionTitle" *ngIf="!isReadOnly">{{'FRONT_USER.REPAIR_REQUEST_FORM.REPAIR_REQUEST' | translate }}</h2>
    <!--request Details summary-->
    <app-request-details *ngIf="requestId" [baseRequest]="baseRequestDTO"></app-request-details>
    <!--request -->

  <!-- <div class="alert alert-success" role="alert" *ngIf="showSuccessMessage">
    {{'FRONT_USER.Floating_Carnes_Request_Form.RequestSuccessfullyCreatedMessage' | translate }}
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="showUnsuccessMessage">
    {{'FRONT_USER.Floating_Carnes_Request_Form.RequestUnsuccessfullyCreatedMessage' | translate }}
  </div> -->

  <form  #repair  [hidden]="showSuccessMessage">
    <div>
      <tabset #repairRequestTabs>
        <!-- tab 1 -->
        <tab heading="{{ 'FRONT_USER.REPAIR_REQUEST_FORM.VESSEL_DESCRIPTION' | translate}}" id="VesselTab">
          <fieldset [disabled]="isReadOnly">
            <div class="form-container" [formGroup]="tabOneForm"  #tabOne>
              <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>

              <!-- VesselName -->
              <div class="form-group">
                <label for="VesselName">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.VESSEL_NAME' | translate}}</label>
                <span class="red"> *</span>
                <input type="text" class="form-control" id="VesselName" name="VesselName"
                  formControlName="VesselName" />
                <div *ngIf="submittedTabOneForm||(fTabOne.VesselName.dirty && fTabOne.VesselName?.errors)" class="red ">
                  <div *ngIf="fTabOne.VesselName?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="fTabOne.VesselName?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_200_ERROR' | translate}}
                  </div>
                  <div *ngIf="fTabOne.VesselName?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>
              <!-- IMONo -->
              <div class="form-group">
                <label for="IMONo">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.IMO_NO' | translate}}</label>
                <span class="red"> *</span>
                <div class="input-group">
                <span class="input-group-addon">IMO</span>
                <input type="text" name="IMONo" id="IMONo" class="form-control" formControlName="IMONo" />
              </div>
                <div *ngIf="submittedTabOneForm||(fTabOne.IMONo?.dirty && fTabOne.IMONo?.errors)" class="red ">
                  <div *ngIf="fTabOne.IMONo?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabOne.IMONo?.errors?.pattern">{{'FRONT_USER.IMO_ERROR' | translate}}</div>
                  <!-- <div *ngIf="fTabOne.IMONo?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
                  </div>
                  <div *ngIf="fTabOne.IMONo?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div> -->
                </div>
              </div>
              <!-- FlagId -->
              <div class="form-group">
                <label for="FlagId">{{'FRONT_USER.REPAIR_REQUEST_FORM.FLAG' | translate}}</label>
                <span class="red"> *</span>
                <select id="FlagId" name="FlagId" class="form-control" formControlName="FlagId">
                  <option [value]="null" selected>{{'FRONT_USER.REPAIR_REQUEST_FORM.CHOOSE_FLAG' | translate}}
                  </option>
                  <ng-container *ngFor="let flag of flag">
                    <option *ngIf="displayedLang=='NameEN'" [value]="flag.Id">
                      {{flag.NameEN}}
                    </option>
                    <option *ngIf="displayedLang=='NameAR'" [value]="flag.Id">
                      {{flag.NameAR}}
                    </option>

                  </ng-container>
                </select>
                <div *ngIf=" (submittedTabOneForm|| fTabOne.FlagId?.touched) && (fTabOne.FlagId?.errors || fTabOne.FlagId?.value=='null')"
                  class="red ">
                  <div *ngIf="fTabOne.FlagId?.errors?.required || fTabOne.FlagId?.value=='null'">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                </div>
              </div>
              <!-- VesselTypeId -->
              <div class="form-group">
                <label for="VesselTypeId">{{'FRONT_USER.REPAIR_REQUEST_FORM.VESSEL_TYPE' | translate}}</label>
                <span class="red"> *</span>
                <select id="VesselTypeId" name="VesselTypeId" class="form-control" formControlName="VesselTypeId">
                  <option [value]="null" selected>{{'FRONT_USER.REPAIR_REQUEST_FORM.CHOOSE_VESSEL_TYPE' | translate}}
                  </option>
                  <ng-container *ngFor="let vessel of vesselType">
                    <option *ngIf="displayedLang=='NameEN'" [value]="vessel.Id">
                      {{vessel.NameEN}}
                    </option>
                    <option *ngIf="displayedLang=='NameAR'" [value]="vessel.Id">
                      {{vessel.NameAR}}
                    </option>
                  </ng-container>
                </select>
                <div
                  *ngIf="(submittedTabOneForm || fTabOne.VesselTypeId?.touched) && (fTabOne.VesselTypeId?.errors || fTabOne.VesselTypeId.value=='null')"
                  class="red">
                  <div *ngIf="fTabOne.VesselTypeId?.errors?.required || fTabOne.VesselTypeId.value=='null'">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                </div>
              </div>
              <!-- ClassificationSocietyId -->
              <div class="form-group">
                <label
                  for="ClassificationSocietyId">{{'FRONT_USER.REPAIR_REQUEST_FORM.CLASSIFICATION_SOCIETY' | translate}}</label>
                <span class="red"> *</span>
                <select id="ClassificationSocietyId" name="ClassificationSocietyId" class="form-control"
                  formControlName="ClassificationSocietyId">
                  <option [value]="null" selected>
                    {{'FRONT_USER.REPAIR_REQUEST_FORM.CHOOSE_CLASSIFICATION_SOCIETY' | translate}}</option>
                  <ng-container *ngFor="let classificationSociety of classificationSociety">
                    <option *ngIf="displayedLang=='NameEN'" [value]="classificationSociety.Id">
                      {{classificationSociety.NameEN}}
                    </option>
                    <option *ngIf="displayedLang=='NameAR'" [value]="classificationSociety.Id">
                      {{classificationSociety.NameAR}}
                    </option>
                  </ng-container>
                </select>
                <div
                  *ngIf="(submittedTabOneForm || fTabOne.ClassificationSocietyId?.touched )&& (fTabOne.ClassificationSocietyId?.errors||fTabOne.ClassificationSocietyId.value=='null') "
                  class="red">
                  <div *ngIf="fTabOne.ClassificationSocietyId?.errors?.required ||fTabOne.ClassificationSocietyId.value=='null'">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <div *ngIf="!isReadOnly">
            <p
              class="btns-holder text-right">

              <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1)">

              <!-- <button [disabled]="f.VesselName?.errors &&f.IMONo?.errors &&f.FlagId?.errors&&f.VesselTypeId?.errors&&f.ClassificationSocietyId?.errors&&f.FlagId.value=='null'&&f.ClassificationSocietyId.value=='null'&&f.VesselTypeId.value=='null'" type="button" class="btn SCAcustomBtn" (click)="selectTab(1)"> -->
                {{'FRONT_USER.NEXT' | translate}}</button>
            </p>
          </div>
          <!-- <div *ngIf="!isReadOnly">
            <p *ngIf="!f.VesselName?.errors &&!f.IMONo?.errors &&!f.FlagId?.errors&&!f.VesselTypeId?.errors&&!f.ClassificationSocietyId?.errors&&f.FlagId.value!='null'&&f.ClassificationSocietyId.value!='null'&&f.VesselTypeId.value!='null'"
              class="btns-holder text-right">
              <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1)">
                {{'FRONT_USER.NEXT' | translate}}</button>
            </p>
          </div> -->

        </tab>

        <!-- tab 2 -->
        <tab heading="{{ 'FRONT_USER.REPAIR_REQUEST_FORM.DIMENSIONS_TONNAGES' | translate}}" id="DimensionsTab"
          [disabled]="!validateTabOne">
          <fieldset [disabled]="isReadOnly">
            <div class="form-container" [formGroup]="tabTwoForm" #tabTwo >
              <!-- LengthOverAll -->
              <div class="form-group">
                <label for="LengthOverAll">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.LOA' | translate}}</label>
                <span class="red"> *</span>
                <div class="split-form-group-units">
                  <input type="text" class="form-control" id="LengthOverAll" name="LengthOverAll"
                    formControlName="LengthOverAll" />
                  <select id="LengthOverAllUnit" name="LengthOverAllUnit" class="form-control"
                    formControlName="LengthOverAllUnit">
                    <option [value]="null" selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                    <option *ngFor="let mesurement of mesurementUnitKeys"  [value]="mesurementUnit[mesurement]">
                      {{'FRONT_USER.REPAIR_REQUEST_FORM.' + mesurement | translate}}
                  </select>
                </div>

                <div *ngIf="submittedtabTwoForm||(fTabTwo.LengthOverAll?.dirty && fTabTwo.LengthOverAll?.errors)" class="red ">
                  <div *ngIf="fTabTwo.LengthOverAll?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="fTabTwo.LengthOverAll?.errors?.pattern"> {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
                </div>
                <div
                  *ngIf="(submittedtabTwoForm || fTabTwo.LengthOverAllUnit?.touched) && ( fTabTwo.LengthOverAllUnit?.errors||fTabTwo.LengthOverAllUnit.value=='null') "
                  class="red ">
                  <div *ngIf="fTabTwo.LengthOverAllUnit?.errors?.required||fTabTwo.LengthOverAllUnit.value=='null'">
                    {{'FRONT_USER.UNIT_Is_Required' | translate}}
                  </div>
                </div>
              </div>
              <!-- LengthBetweenPerpendiculars -->
              <div class="form-group">
                <label for="LengthBetweenPerpendiculars">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.LBP' | translate}}</label>
                <span class="red"> *</span>
                <div class="split-form-group-units"> <input type="text" class="form-control"
                    id="LengthBetweenPerpendiculars" name="LengthBetweenPerpendiculars"
                    formControlName="LengthBetweenPerpendiculars" />
                  <select id="LengthBetweenPerpendicularsUnit" name="LengthBetweenPerpendicularsUnit"
                    class="form-control" formControlName="LengthBetweenPerpendicularsUnit">
                    <option [value]="null" selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                    <option *ngFor="let mesurement of mesurementUnitKeys"  [value]="mesurementUnit[mesurement]">
                      {{'FRONT_USER.REPAIR_REQUEST_FORM.' + mesurement | translate}}
                  </select>
                </div>

                <div *ngIf="submittedtabTwoForm|| (fTabTwo.LengthBetweenPerpendiculars?.dirty &&fTabTwo.LengthBetweenPerpendiculars?.errors)"
                  class="red">
                  <div *ngIf="fTabTwo.LengthBetweenPerpendiculars?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabTwo.LengthBetweenPerpendiculars?.errors?.pattern">
                    {{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
                </div>
                <div
                  *ngIf="(submittedtabTwoForm || fTabTwo.LengthBetweenPerpendicularsUnit?.touched) && (fTabTwo.LengthBetweenPerpendicularsUnit?.errors||fTabTwo.LengthBetweenPerpendicularsUnit.value=='null')"
                  class="red">
                  <div
                    *ngIf="fTabTwo.LengthBetweenPerpendicularsUnit?.errors?.required||fTabTwo.LengthBetweenPerpendicularsUnit.value=='null'">
                    {{'FRONT_USER.UNIT_Is_Required' | translate}}</div>
                </div>
              </div>

              <!-- Beam -->
              <div class="form-group">
                <label for="Beam">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.BEAM' | translate}}</label>
                <span class="red"> *</span>
                <div class="split-form-group-units">
                  <input type="text" class="form-control" id="Beam" name="Beam" formControlName="Beam" />
                  <select id="BeamUnit" name="BeamUnit" class="form-control" formControlName="BeamUnit">
                    <option [value]="null" selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                    <option *ngFor="let mesurement of mesurementUnitKeys"  [value]="mesurementUnit[mesurement]">
                      {{'FRONT_USER.REPAIR_REQUEST_FORM.' + mesurement | translate}}

                  </select>
                </div>
                <div *ngIf="submittedtabTwoForm||( fTabTwo.Beam?.dirty && fTabTwo.Beam?.errors)" class="red">
                  <div *ngIf="fTabTwo.Beam?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabTwo.Beam?.errors?.pattern"> {{'FRONT_USER.NUMBER_ERROR' | translate}}</div>

                </div>
                <div *ngIf="(submittedtabTwoForm || fTabTwo.BeamUnit?.touched) && (fTabTwo.BeamUnit?.errors||fTabTwo.BeamUnit.value=='null')"
                  class="red ">
                  <div *ngIf="fTabTwo.BeamUnit?.errors?.required||fTabTwo.BeamUnit.value=='null'">
                    {{'FRONT_USER.UNIT_Is_Required' | translate}}</div>
                </div>
              </div>

              <!-- MouldedDepth -->
              <div class="form-group">
                <label for="MouldedDepth">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.MOULDED_DEPTH' | translate}}</label>
                <span class="red"> *</span>
                <div class="split-form-group-units">
                  <input type="text" class="form-control" id="MouldedDepth" name="MouldedDepth"
                    formControlName="MouldedDepth" />
                  <select id="MouldedDepthUnit" name="MouldedDepthUnit" class="form-control"
                    formControlName="MouldedDepthUnit">
                    <option [value]="null" selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                    <option *ngFor="let mesurement of mesurementUnitKeys"  [value]="mesurementUnit[mesurement]">
                      {{'FRONT_USER.REPAIR_REQUEST_FORM.' + mesurement | translate}}

                  </select>
                </div>
                <div *ngIf="submittedtabTwoForm||(fTabTwo.MouldedDepth?.dirty && fTabTwo.MouldedDepth?.errors)" class="red">
                  <div *ngIf="fTabTwo.MouldedDepth?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="fTabTwo.MouldedDepth?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}} </div>
                </div>

                <div
                  *ngIf="(submittedtabTwoForm||fTabTwo.MouldedDepthUnit?.touched) && (fTabTwo.MouldedDepthUnit?.errors||fTabTwo.MouldedDepthUnit.value=='null')"
                  class="red">
                  <div *ngIf="fTabTwo.MouldedDepthUnit?.errors?.required||fTabTwo.MouldedDepthUnit.value=='null'">
                    {{'FRONT_USER.UNIT_Is_Required' | translate}}
                  </div>
                </div>
              </div>


              <!--Tonnages Data section-->
              <div class="form-section">

                <h4 class="section-title">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TONNAGE_DATA' | translate}}</h4>
                <!--SuezCanalNetTonnage-->

                <div class="form-group">
                  <label
                    for="SuezCanalNetTonnage">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.SUEZ_CANNAL_NET_TONNAGE' | translate}}</label>
                  <div class="input-group">
                    <input type="text" class="form-control" id="SuezCanalNetTonnage" name="SuezCanalNetTonnage"
                      formControlName="SuezCanalNetTonnage" />
                    <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>
                  </div>
                  <div *ngIf="submittedtabTwoForm ||(fTabTwo.SuezCanalNetTonnage?.dirty && fTabTwo.SuezCanalNetTonnage?.errors)" class="red">
                    <div *ngIf="fTabTwo.SuezCanalNetTonnage?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}
                    </div>
                  </div>

                </div>
                <!--SuezCanalGrossTonnage-->
                <div class="form-group">
                  <label
                    for="SuezCanalGrossTonnage">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.SUEZ_CANNAL_GROSS_TONNAGE' | translate}}</label>
                  <span class="red"> *</span>
                  <div class="input-group">
                    <input type="text" class="form-control" id="SuezCanalGrossTonnage" name="SuezCanalGrossTonnage"
                      formControlName="SuezCanalGrossTonnage" />
                    <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>
                  </div>
                  <div *ngIf="submittedtabTwoForm ||(fTabTwo.SuezCanalGrossTonnage?.dirty && fTabTwo.SuezCanalGrossTonnage?.errors)"
                    class="red">
                    <div *ngIf="fTabTwo.SuezCanalGrossTonnage?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                    <div *ngIf="fTabTwo.SuezCanalGrossTonnage?.errors?.pattern">
                      {{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>

            <p class="btns-holder text-right" *ngIf="!isReadOnly">
              <button type="button" class="btn SCAcustomBtn"
                (click)="selectTab(0)">{{'FRONT_USER.PREVIOUS' | translate}}</button>

                <button  type="button" class="btn SCAcustomBtn"
                  (click)="selectTab(2) ">{{'FRONT_USER.NEXT' | translate}}</button>
              </p>

              <!-- <button *ngIf="!f.LengthOverAll?.errors &&!f.LengthOverAllUnit?.errors
              &&!f.LengthBetweenPerpendiculars?.errors &&!f.LengthBetweenPerpendicularsUnit?.error
              &&f.LengthOverAllUnit.value!='null'&&f.LengthBetweenPerpendicularsUnit.value!='null'
             &&!f.Beam?.errors &&!f.MouldedDepth?.errors&&!f.BeamUnit?.errors&&f.BeamUnit.value!='null'
              &&!f.MouldedDepthUnit?.errors&&f.MouldedDepthUnit.value!='null'
              &&!f.SuezCanalGrossTonnage?.errors " type="button" class="btn SCAcustomBtn"
                (click)="selectTab(2) ">{{'FRONT_USER.NEXT' | translate}}</button>
            </p> -->




          </fieldset>
        </tab>

        <!-- tab 3 -->
        <tab heading="{{ 'FRONT_USER.REPAIR_REQUEST_FORM.DOCKING_CONDITION' | translate}}" id="DockingTab"
          [disabled]="!validateTabTwo||!validateTabOne">
          <fieldset [disabled]="isReadOnly">
            <div class="form-container" [formGroup]="tabThreeForm" #tabThree>
              <!-- Lightweight -->
              <div class="form-group">
                <label for="Lightweight">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.LIGHT_WEIGHT' | translate}}</label>
                <span class="red"> *</span>
                <div class="input-group">
                  <input type="text" class="form-control" id="Lightweight" name="Lightweight"
                    formControlName="Lightweight" />
                  <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>
                </div>
                <div *ngIf="submittedtabThreeForm|| (fTabThree.Lightweight?.dirty && fTabThree.Lightweight?.errors)" class="red">
                  <div *ngIf="fTabThree.Lightweight?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabThree.Lightweight?.errors?.pattern"> {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
                </div>
              </div>
              <!-- Deadweight -->
              <div class="form-group">
                <label for="Deadweight">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.DEAD_WEIGHT' | translate}}</label>
                <span class="red"> *</span>
                <div class="input-group">
                  <input type="text" class="form-control" id="Deadweight" name="Deadweight"
                    formControlName="Deadweight" />
                  <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>
                </div>
                <div *ngIf="submittedtabThreeForm || (fTabThree.Deadweight?.dirty && fTabThree.Deadweight?.errors)" class="red">
                  <div *ngIf="fTabThree.Deadweight?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabThree.Deadweight?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>

                </div>
              </div>

              <!-- Displacement -->
              <div class="form-group">
                <label for="Displacement">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.DISPLACEMENT' | translate}}</label>
                <span class="red"> *</span>
                <div class="input-group">
                  <input type="text" class="form-control" id="Displacement" name="Displacement"
                    formControlName="Displacement" />
                  <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>

                </div>
                <div *ngIf="submittedtabThreeForm || (fTabThree.Displacement?.dirty && fTabThree.Displacement?.errors)" class="red">
                  <div *ngIf="fTabThree.Displacement?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                    <div *ngIf="fTabThree.Displacement?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}

                    </div>

                </div>
              </div>
              <!-- Draught -->
              <div class="form-group">
                <label for="Draught">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.DRAUGHT' | translate}}</label>
                <span class="red"> *</span>
                <div class="split-form-group-units">
                  <input type="text" class="form-control" id="Draught" name="Draught" formControlName="Draught" />
                  <select id="DraughtUnit" name="DraughtUnit" class="form-control" formControlName="DraughtUnit">
                    <option [value]="null" selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                    <option *ngFor="let mesurement of mesurementUnitKeys"  [value]="mesurementUnit[mesurement]">
                      {{'FRONT_USER.REPAIR_REQUEST_FORM.' + mesurement | translate}}

                  </select>
                </div>
                <div *ngIf="submittedtabThreeForm ||(fTabThree.Draught?.dirty && fTabThree.Draught?.errors)" class="red">
                  <div *ngIf="fTabThree.Draught?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabThree.Draught?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
                </div>
                <div
                  *ngIf="(submittedtabThreeForm || fTabThree.DraughtUnit?.touched) && (fTabThree.DraughtUnit?.errors||fTabThree.DraughtUnit.value=='null')"
                  class="red">
                  <div *ngIf="fTabThree.DraughtUnit?.errors?.required||fTabThree.DraughtUnit.value=='null'">
                    {{'FRONT_USER.UNIT_Is_Required' | translate}}</div>
                </div>
              </div>

              <!-- Trim -->
              <div class="form-group">
                <label for="Trim">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TRIM' | translate}}</label>
                <span class="red"> *</span>
                <div class="split-form-group-units">
                  <input type="text" class="form-control" id="Trim" name="Trim" formControlName="Trim" />
                  <select id="TrimUnit" name="TrimUnit" class="form-control" formControlName="TrimUnit">
                    <option [value]="null" selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                    <option *ngFor="let mesurement of mesurementUnitKeys"  [value]="mesurementUnit[mesurement]">
                      {{'FRONT_USER.REPAIR_REQUEST_FORM.' + mesurement | translate}}

                  </select>
                </div>
                <div *ngIf="submittedtabThreeForm ||(fTabThree.Trim?.dirty && fTabThree.Trim?.errors)" class="red">
                  <div *ngIf="fTabThree.Trim?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabThree.Trim?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
                </div>
                <div *ngIf="(submittedtabThreeForm || fTabThree.TrimUnit?.touched) &&(fTabThree.TrimUnit?.errors||fTabThree.TrimUnit.value=='null')"
                  class="red">
                  <div *ngIf="fTabThree.TrimUnit?.errors?.required||fTabThree.TrimUnit.value=='null'">
                    {{'FRONT_USER.UNIT_Is_Required' | translate}}</div>

                </div>
              </div>

              <!-- List -->
              <div class="form-group">
                <label for="List">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.LIST' | translate}}</label>
                <span class="red"> *</span>
                <div class="split-form-group-units">
                  <input type="text" class="form-control" id="List" name="Trim" formControlName="List" />
                  <select id="ListUnit" name="ListUnit" class="form-control" formControlName="ListUnit">
                    <option [value]='null' selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                    <option *ngFor="let mesurement of mesurementUnitKeys"  [value]="mesurementUnit[mesurement]">
                      {{'FRONT_USER.REPAIR_REQUEST_FORM.' + mesurement | translate}}

                  </select>
                </div>

                <div *ngIf="submittedtabThreeForm ||(fTabThree.List?.dirty && fTabThree.List?.errors)" class="red">
                  <div *ngIf="fTabThree.List?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabThree.List?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>

                </div>
                <div *ngIf="(submittedtabThreeForm || fTabThree.ListUnit?.touched) && (fTabThree.ListUnit?.errors||fTabThree.ListUnit.value=='null')"
                  class="red">
                  <div *ngIf="fTabThree.ListUnit?.errors?.required||fTabThree.ListUnit.value=='null'">
                    {{'FRONT_USER.UNIT_Is_Required' | translate}}</div>
                </div>
              </div>

            </div>

            <p class="btns-holder text-right" *ngIf="!isReadOnly">
              <button type="button" class="btn SCAcustomBtn"
                (click)="selectTab(1)">{{'FRONT_USER.PREVIOUS' | translate}}</button>
              <button  type="button" class="btn SCAcustomBtn"
                (click)="selectTab(3) ">{{'FRONT_USER.NEXT' | translate}}</button>
            </p>

          </fieldset>
        </tab>

        <!-- tab 4 -->
        <tab heading="{{ 'FRONT_USER.REPAIR_REQUEST_FORM.ELECTRICAL_DATA' | translate}}" id="ElectricalTab"
          [disabled]="!validateTabThree||!validateTabTwo||!validateTabOne">
          <fieldset [disabled]="isReadOnly">
            <div class="form-container" [formGroup]="tabFourForm">
              <!-- Frequency -->
              <div class="form-group">
                  <label for="Frequency">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.FREQUENCY' | translate}}</label>
                  <span class="red"> *</span>
                  <select id="Frequency" name="Frequency" class="form-control" formControlName="Frequency" >
                    <option [value]="null" selected>{{'FRONT_USER.REPAIR_REQUEST_FORM.CHOOSE_FRECUENCY' | translate}}
                    </option>
                      <option *ngFor="let freq of frequencyKeys" [value]="frequency[freq]" >
                          {{'FRONT_USER.REPAIR_REQUEST_FORM.' + freq | translate }}
                      </option>
                  </select>
                  <!-- && (fTabFour.Frequency?.errors || fTabFour.Frequency?.value=='null') -->
                  <!-- ||fTabFour.Frequency?.value=='null'" -->
                  <!-- (submittedtabFourForm || fTabFour.FrequencyUnit?.touched) && (fTabFour.FrequencyUnit?.errors||fTabFour.FrequencyUnit.value=='null') -->
                 <div *ngIf=" (submittedtabFourForm||fTabFour.Frequency?.touched) && (fTabFour.Frequency?.errors || fTabFour.Frequency?.value=='null' )"
                    class="red ">
                    <div *ngIf="fTabFour.Frequency?.errors?.required||fTabFour.Frequency?.value=='null' ">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                    </div>
                </div>



              <!-- <div class="form-group">
                <label for="Frequency">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.FREQUENCY' | translate}}</label>
                <span class="red"> *</span>
                <div class="split-form-group-units">
                  <input type="text" class="form-control" id="Frequency" name="Frequency" formControlName="Frequency" />
                  <select id="FrequencyUnit" name="FrequencyUnit" class="form-control" formControlName="FrequencyUnit">
                    <option [value]="null" selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                    <option *ngFor="let mesurement of frequecyKeys"  [value]="frequency[mesurement]">
                      {{'FRONT_USER.REPAIR_REQUEST_FORM.' + mesurement | translate}}
                  </select>
                </div>
                <div *ngIf="submittedtabFourForm ||(fTabFour.Frequency?.dirty && fTabFour.Frequency?.errors)" class="red">
                  <div *ngIf="fTabFour.Frequency?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabFour.Frequency?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>

                </div>
                <div
                  *ngIf="(submittedtabFourForm || fTabFour.FrequencyUnit?.touched) && (fTabFour.FrequencyUnit?.errors||fTabFour.FrequencyUnit.value=='null')"
                  class="red">
                  <div *ngIf="fTabFour.FrequencyUnit?.errors?.required||fTabFour.FrequencyUnit.value=='null'">
                    {{'FRONT_USER.UNIT_Is_Required' | translate}}
                  </div>
                </div>
              </div> -->

              <!-- RatedCurrentDuringDocking -->
              <div class="form-group">
                <label
                  for="RatedCurrentDuringDocking">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.RATED_CURRENT_DURING_DOCKING' | translate}}</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="RatedCurrentDuringDocking"
                    name="RatedCurrentDuringDocking" formControlName="RatedCurrentDuringDocking" />
                  <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.AMPERE' | translate}}</span>

                </div>
                <div *ngIf="submittedtabFourForm ||(fTabFour.RatedCurrentDuringDocking?.dirty && fTabFour.RatedCurrentDuringDocking?.errors)"
                  class="red">
                  <div *ngIf="fTabFour.RatedCurrentDuringDocking?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>

                </div>
              </div>
            </div>



            <p class="btns-holder text-right" *ngIf="!isReadOnly">
              <button type="button" class="btn SCAcustomBtn"
                (click)="selectTab(2)">{{'FRONT_USER.PREVIOUS' | translate}}</button>
              <button
                type="button" class="btn SCAcustomBtn"
                (click)="selectTab(4) ">{{'FRONT_USER.NEXT' | translate}}</button>
            </p>


          </fieldset>
        </tab>

        <!-- tab 5 -->
        <tab heading="{{ 'FRONT_USER.REPAIR_REQUEST_FORM.SCOPE_OF_WORK_DATA' | translate}} " id="ScopeTab"
          [disabled]="!validateTabFour||!validateTabThree||!validateTabTwo||!validateTabOne">
          <fieldset [disabled]="isReadOnly">
            <div class="form-container" [formGroup]="tabFiveForm">
              <!-- DetailedScopeOfWork -->
              <div class="form-group" *ngIf="!isReadOnly">

                <label>{{'FRONT_USER.REPAIR_REQUEST_FORM.DETAILED_SCOPE_OF_WORK'|translate}}</label>
                <span class="red"> *</span>
                <input type="file" class="form-control" MaxSizeInMB="5" accept=".DXF,.doc,.docx,.pdf,.gif, .jpg, .jpeg, .png, .bmp"
                  id="ShipPhotoInput" formControlName="DetailedScopeOfWork"
                  (change)="onFileSelected($event,fTabFive.DetailedScopeOfWork,'Detailed_Scope_Of_Work',9,'detailedScopeOfWorkProgress','FRONT_USER.REPAIR_REQUEST_FORM.DETAILED_SCOPE_OF_WORK')" />

                  <div class="upload-info">
                  <span data-toggle="tooltip"

                    title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                  <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
                </div>
                <div *ngIf="submittedtabFiveForm &&fTabFive.DetailedScopeOfWork?.errors||( fTabFive.DetailedScopeOfWork?.errors&&fTabFive.DetailedScopeOfWork?.dirty)" class="red ">
                  <div *ngIf="fTabSix.DockingPlan?.errors">
                    {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}</div>

                  <div *ngIf="fTabFive.DetailedScopeOfWork?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                </div>
                <div class="progress" *ngIf="!isReadOnly">
                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="detailedScopeOfWorkProgress + '%'">
                    <span class=""> {{detailedScopeOfWorkProgress}} % Complete</span>
                  </div>
                </div>
              </div>

              <div class="form-group" *ngIf="isReadOnly&&detauiledScopeOfWorkExist" >
                <div id="attachmentsUrls"  class=" read-uploaded">
                <label>{{ 'FRONT_USER.REPAIR_REQUEST_FORM.DETAILED_SCOPE_OF_WORK' | translate}}</label>
                <a [attr.href]="detauiledScopeOfWorkAttachmentUrl" target="_blank">
                  <i class="icon-view-file"></i>
                  {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
                </a>
              </div>
              </div>





              <!-- RequiredDockingDate -->
              <div class="form-group">
                <label>{{'FRONT_USER.REPAIR_REQUEST_FORM.REQUIRED_DOCKING_DATE'|translate}}</label>
                <span class="red"> *</span>
                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
                  formControlName="RequiredDockingDate"
                  [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass : 'theme-dark-blue' }">

                <div *ngIf="(fTabFive.RequiredDockingDate?.errors && submittedtabFiveForm) || (fTabFive.RequiredDockingDate?.errors && fTabFive.RequiredDockingDate?.dirty)" class="red">
                  <div *ngIf="fTabFive.RequiredDockingDate?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="fTabFive.RequiredDockingDate?.errors?.inValidDateError">{{'FRONT_USER.DATE_ERROR' | translate}}
                  </div>

                </div>
              </div>

            </div>

            <p class="btns-holder text-right" *ngIf="!isReadOnly">
              <button type="button" class="btn SCAcustomBtn"
                (click)="selectTab(3)">{{'FRONT_USER.PREVIOUS' | translate}}</button>
              <button
                class="btns-holder text-right" type="button" class="btn SCAcustomBtn"
                (click)="selectTab(5) ">{{'FRONT_USER.NEXT' | translate}}</button>
            </p>

          </fieldset>
        </tab>

        <!-- tab 6 -->
        <tab heading="{{ 'FRONT_USER.REPAIR_REQUEST_FORM.REQUIRED_DRAWINGS' | translate}}" id="drawingsTab"
          [disabled]="!validateTabFive||!validateTabFour||!validateTabThree||!validateTabTwo||!validateTabOne" #tabSix>
          <fieldset id="filesInputsFieldSet" *ngIf="!isReadOnly">
            <div class="form-container" [formGroup]="tabSixForm">
              <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
              <!-- DockingPlan -->
              <div class="form-group">
                <label>{{'FRONT_USER.REPAIR_REQUEST_FORM.DOCKING_PLAN'|translate}}</label>
                <span class="red"> *</span>
                <input type="file" class="form-control" MaxSizeInMB="5"
                  accept=".DXF,.pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx" id="ShipPhotoInput"
                  formControlName="DockingPlan"
                  (change)="onFileSelected($event,fTabSix.DockingPlan,'DockingPlan_Plan',3,'dockingPlanProgress','FRONT_USER.REPAIR_REQUEST_FORM.DOCKING_PLAN')" />
                  <div class="upload-info">
                  <span data-toggle="tooltip"
                    title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                  <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
                </div>
                <div *ngIf="submittedtabSixForm||(fTabSix.DockingPlan?.touched && fTabSix.DockingPlan?.errors)" class="red">
                  <!-- {{'FRONT_USER.This_Field_Is_Required' | translate}} -->
                  <div *ngIf="fTabSix.DockingPlan?.errors">
                    {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}</div>
                  <div *ngIf="fTabSix.DockingPlan?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

                </div>
                <div class="progress">
                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="dockingPlanProgress + '%'">
                    <span class=""> {{dockingPlanProgress}} % Complete</span>
                  </div>
                </div>

              </div>

              <!-- GeneralArrangement -->
              <div class="form-group">
                <label>{{'FRONT_USER.REPAIR_REQUEST_FORM.GENERAL_ARRANGEMENT'|translate}}</label>
                <span class="red"> *</span>
                <input type="file" MaxSizeInMB="5" accept=".DXF,.pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx"
                  class="form-control" id="ShipPhotoInput" formControlName="GeneralArrangement"
                  (change)="onFileSelected($event,fTabSix.GeneralArrangement,'General_Arrangement',4,'generalArrangementProgress','FRONT_USER.REPAIR_REQUEST_FORM.GENERAL_ARRANGEMENT')" />

                  <div class="upload-info">
                  <span data-toggle="tooltip"
                    title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                  <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
                </div>
                <div *ngIf="submittedtabSixForm||(fTabSix.GeneralArrangement?.touched && fTabSix.GeneralArrangement?.errors)" class="red">
                  <div *ngIf="fTabSix.GeneralArrangement?.errors">
                    {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}</div>
                  <div *ngIf="fTabSix.GeneralArrangement?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

                </div>
                <div class="progress">
                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="generalArrangementProgress + '%'">
                    <span class=""> {{generalArrangementProgress}} % Complete</span>
                  </div>
                </div>
              </div>


              <!-- TANK_PLAN -->
              <div class="form-group">
                <label>{{'FRONT_USER.REPAIR_REQUEST_FORM.TANK_PLAN'|translate}}</label>
                <input type="file" MaxSizeInMB="5" accept=".DXF,.pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx"
                  class="form-control" id="ShipPhotoInput" formControlName="TankPlan"
                  (change)="onFileSelected($event,fTabSix.TankPlan,'Tank_Plan',5,'tankPlanProgress','FRONT_USER.REPAIR_REQUEST_FORM.TANK_PLAN')" />
                <div class="upload-info">
                  <span data-toggle="tooltip"
                    title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                  <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
                </div>
                <div *ngIf="(fTabSix.TankPlan?.touched && fTabSix.TankPlan?.errors)" class="red">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>

                <div class="progress">
                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="tankPlanProgress + '%'">
                    <span class=""> {{tankPlanProgress}} % Complete</span>
                  </div>
                </div>
              </div>


              <!-- LinesPlan -->
              <div class="form-group">
                <label>{{'FRONT_USER.REPAIR_REQUEST_FORM.LINES_PLAN'|translate}}</label>

                <input type="file" MaxSizeInMB="5" accept=".DXF,.pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx"
                  class="form-control" id="ShipPhotoInput" formControlName="LinesPlan"
                  (change)="onFileSelected($event,fTabSix.LinesPlan,'Lines_Plan',6,'linesPlanProgress','FRONT_USER.REPAIR_REQUEST_FORM.LINES_PLAN')" />
                <div class="upload-info">
                  <span data-toggle="tooltip"
                    title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                  <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
                </div>
                <div *ngIf="(fTabSix.LinesPlan?.touched && fTabSix.LinesPlan?.errors)" class="red">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
                <div class="progress">
                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="linesPlanProgress + '%'">
                    <span class=""> {{linesPlanProgress}} % Complete</span>
                  </div>
                </div>
              </div>


              <!-- TranverseSectionPlan -->
              <div class="form-group">
                <label>{{'FRONT_USER.REPAIR_REQUEST_FORM.TRANSVERSE_SECTION_PLAN'|translate}}</label>

                <input type="file" class="form-control" MaxSizeInMB="5"
                  accept=".DXF,.pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx" id="ShipPhotoInput"
                  formControlName="TransverseSectionPlan"
                  (change)="onFileSelected($event,fTabSix.TransverseSectionPlan,'Trnsverse_Section_Plan',7,'tranverseSectionPlanProgress','FRONT_USER.REPAIR_REQUEST_FORM.TRANSVERSE_SECTION_PLAN')" />
                <div class="upload-info">
                  <span data-toggle="tooltip"
                    title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                  <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
                </div>
                <div *ngIf="(fTabSix.TransverseSectionPlan?.touched && fTabSix.TransverseSectionPlan?.errors)" class="red">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
                <div class="progress">
                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="tranverseSectionPlanProgress + '%'">
                    <span class=""> {{tranverseSectionPlanProgress}} % Complete</span>
                  </div>
                </div>
              </div>



              <!-- FreeGasCertificate -->
              <div class="form-group">
                <label>{{'FRONT_USER.REPAIR_REQUEST_FORM.FREE_GAS_CERTIFICATE'|translate}}</label>

                <input type="file" class="form-control" MaxSizeInMB="5"
                  accept=".pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc ,.docx" id="ShipPhotoInput"
                  formControlName="FreeGasCertificate"
                  (change)="onFileSelected($event,fTabSix.FreeGasCertificate,'FreeGas_Certificate',8,'freeGasCertificateProgress','FRONT_USER.REPAIR_REQUEST_FORM.FREE_GAS_CERTIFICATE')" />
                <div class="upload-info">
                  <span data-toggle="tooltip"
                    title="{{'FRONT_USER.REPAIR_REQUEST_FORM.ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                  <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
                </div>
                <div *ngIf="(fTabSix.FreeGasCertificate?.touched && fTabSix.FreeGasCertificate?.errors)" class="red">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
                <div class="progress">
                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="freeGasCertificateProgress + '%'">
                    <span class=""> {{freeGasCertificateProgress}} % Complete</span>
                  </div>
                </div>
              </div>



              <!-- WorkDescription -->
              <div class="form-group">
                <label for="WorkDescription">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION' | translate}}</label>
                <textarea class="form-control" id="WorkDescription" name="WorkDescription"
                  formControlName="WorkDescription" style="height: 186px;  width: 400px;"></textarea>
                <div *ngIf="submittedtabSixForm||( fTabSix.WorkDescription?.dirty && fTabSix.WorkDescription?.errors)" class="red">
                  <!-- <div *ngIf="fTabSix.WorkDescription?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div> -->
                  <div *ngIf="fTabSix.WorkDescription?.errors?.maxlength">
                    {{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
                  <div *ngIf="fTabSix.WorkDescription?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <p class="btns-holder text-right" *ngIf="!isReadOnly">
              <button type="button" class="btn SCAcustomBtn"
                (click)="selectTab(4)">{{'FRONT_USER.PREVIOUS' | translate}}</button>

              <button
                type="button" class="btn SCAcustomBtn"
                (click)="selectTab(6) ">{{'FRONT_USER.NEXT' | translate}}</button>
            </p>


          </fieldset>
          <!--change attahment controls in read only mode-->
          <div id="attachmentsUrls" *ngIf="isReadOnly" class="form-container read-uploaded" [formGroup]="tabSixForm">

            <div class="form-group" *ngIf='dockingPlanExist'>
              <label>{{ 'FRONT_USER.REPAIR_REQUEST_FORM.DOCKING_PLAN' | translate}}</label>
              <a [attr.href]="dockingPlanAttachmentUrl" target="_blank">
                <i class="icon-view-file"></i>
                {{'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div class="form-group"  *ngIf='generalArrangementExist'>
              <label>{{ 'FRONT_USER.REPAIR_REQUEST_FORM.GENERAL_ARRANGEMENT' | translate}}</label>
              <a [attr.href]="generalArrangementAttachmentUrl" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>

            <div class="form-group"  *ngIf='tankPlanExist' >
              <label>{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TANK_PLAN' | translate}}</label>
              <a [attr.href]="tankPlanAttachmentUrl" target="_blank"  >
                <i class="icon-view-file"></i>
                {{'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
            </a>
            </div>

            <div class="form-group" *ngIf='linesPlanExist'>
              <label>{{ 'FRONT_USER.REPAIR_REQUEST_FORM.LINES_PLAN' | translate}}</label>
              <a [attr.href]="linesPlanAttachmentUrl" target="_blank">
                <i class="icon-view-file"></i>
                {{'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>

            <div class="form-group" *ngIf='transvewseSectionPlanExist'>
              <label>{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TRANSVERSE_SECTION_PLAN' | translate}}</label>
              <a [attr.href]="transvewseSectionPlanAttachmentUrl" target="_blank">
                  <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>

            <div class="form-group" *ngIf= 'gasCertificatePlanExist'>
              <label>{{ 'FRONT_USER.REPAIR_REQUEST_FORM.FREE_GAS_CERTIFICATE' | translate}}</label>
              <a [attr.href]="gasCertificatePlanAttachmentUrl" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>


              <!-- WorkDescription -->
              <div class="form-group">
                <label for="WorkDescription">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION' | translate}}</label>
                <textarea   class="form-control" id="WorkDescription" name="WorkDescription"
                  formControlName="WorkDescription" style="height: 186px;  width: 400px;"></textarea>
                <div *ngIf="submittedtabSixForm||( fTabSix.WorkDescription?.dirty && fTabSix.WorkDescription?.errors)" class="red">
                  <!-- <div *ngIf="fTabSix.WorkDescription?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div> -->
                  <div *ngIf="fTabSix.WorkDescription?.errors?.maxlength">
                    {{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
                    <div *ngIf="fTabSix.WorkDescription?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
                      </div>
                </div>
              </div>
            </div>


        </tab>

        <!-- tab 7 -->
        <tab heading="{{ 'FRONT_USER.REPAIR_REQUEST_FORM.OTHER_INFORMATION' | translate}}" id="informationTab"
          [disabled]="!validateTabSix||!validateTabFive||!validateTabFour||!validateTabThree||!validateTabTwo||!validateTabOne">
          <fieldset [disabled]="isReadOnly">
            <!-- AUTHORITY -->
           <div class="form-container" [formGroup]="tabSevenForm">
              <!--  <div class="form-group">
                <label >{{ 'FRONT_USER.REPAIR_REQUEST_FORM.AUTHORITY' | translate }}</label>
                <div class="form-custom-inputs">
                  <div class="custom-Radio"  *ngFor="let auth of authorityKeys;let i='index'">
                    <input [id]="[auth]"  type="radio"  name="Authority"  [value]="authority[auth]"
                       formControlName="Authority" />
                    <label [for]="[auth]">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.' + auth | translate }}</label>
                  </div>

                </div>
              </div> -->
              <!-- NearestLocation -->
              <div class="form-group">
                <label >{{ 'FRONT_USER.REPAIR_REQUEST_FORM.NEAREST_LOCATION' | translate }}</label>
                <span class="red"> *</span>
                <div class="form-custom-inputs">
                  <div class="custom-Radio"   *ngFor="let location of nearestLocationKeys;let i='index'">
                    <input [id]="[location]"   type="radio"  name="NearestLocation"  [value]="nearestLocation[location]"
                       formControlName="NearestLocation" />
                    <label [for]="[location]">{{'FRONT_USER.REPAIR_REQUEST_FORM.' + location | translate }}</label>
                  </div>
                </div>
                <div *ngIf="submittedtabSevenForm && fTabSeven.NearestLocation?.errors" class="red ">
                  <div *ngIf="fTabSeven.NearestLocation?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>

                </div>
              </div>
            </div>

            <app-user-request-details [UserRequestDetailsformGroup]="tabSevenForm" [extrnalData]="userInfo" [IsReadOnly]="isReadOnly"
              [SubmitFlag]="submitted" [IsCustomerName]="false" [IsFaxOptional]="true"></app-user-request-details>
            <!-- TermsAndConditions -->
             <div class="form-group" *ngIf="!isReadOnly" [formGroup]="tabSevenForm">
              <label
                for="TermsAndConditions">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS' | translate }}</label>
              <span class="red"> *</span>
              <div class="custom-checkbox">
                <input type="checkbox" class="form-control" id="TermsAndConditions" name="TermsAndConditions"
                  formControlName="TermsAndConditions" />
                <label for="TermsAndConditions">
                    <a (click)="goToTermsAndConditions()" target="_blank" >{{ 'FRONT_USER.TERMS_CONDITIONS_Acceptence' | translate }}</a>

                    </label>
              </div>
              <div *ngIf="submittedtabSevenForm && fTabSeven.TermsAndConditions?.errors" class="red ">
                <div *ngIf="fTabSeven.TermsAndConditions?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>

            </div>

            <div *ngIf="!isReadOnly">
              <p class="btns-holder text-right">
                <button type="button" class="btn SCAcustomBtn"
                  (click)="selectTab(5)">{{'FRONT_USER.PREVIOUS' | translate}}</button>
              </p>
            </div>
          </fieldset>

        </tab>

      </tabset>
       <div class="form-group" *ngIf="!isReadOnly">
          <button Confirmation (confirmationClick)="onSubmit()" *ngIf="validateButton"
           [disabled]="loading" class="btn SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
        </div>



    </div>




  </form>


</div>

<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">{{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>


<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>

<div *ngIf="requestId">
  <app-messaging></app-messaging>
</div>
